import moment from 'moment';

export const daysInMonth = (month, year) => {
  return new Date(year, month, 0).getDate();
};

export const isInWeek = (activeDate, weekDate) => {
  return moment(activeDate).isoWeek() === moment(weekDate).isoWeek();
};